<!--reusable component for button
component imported as Button in all other files
-->
<template>
  <v-btn
    :class="{
      'white--text': !(outline || textButton),
      [additionalClass]: additionalClass,
      'theme-button': themeButton,
      'btn-class': !textButton
    }"
    :type="buttonType"
    :tile="square"
    :icon="icon"
    :outlined="outline"
    elevation="0"
    :large="size === 'large' && true"
    :small="size === 'small' && true"
    :color="color"
    :disabled="loading || disabled"
    :text="textButton"
    :ripple="!textButton"
    @click.stop="buttonType === 'click' && clickEvent()"
  >
    {{ buttonText }}<slot name="button_children"></slot
  ></v-btn>
</template>

<script>
export default {
  data() {
    return {
      loading: false
    };
  },
  methods: {
    // on click function(like what happens when someone click the button )
    async clickEvent() {
      this.loading = true;
      if (this.clickFunction) {
        await this.clickFunction();
      }
      this.$emit('click');
      this.loading = false;
    }
  },

  props: {
    filled: {
      type: Boolean,
      default: true,
      required: false
    },
    disabled: { type: Boolean, default: false },
    themeButton: {
      type: Boolean,
      default: false,
      required: false
    },
    outline: {
      type: Boolean,
      default: false,
      required: false
    },
    icon: {
      type: Boolean,
      default: false,
      required: false
    },
    additionalClass: String,
    size: String,
    buttonText: { type: String, default: 'Submit' },
    clickFunction: Function,
    color: String,
    buttonType: { type: String, default: 'click' },
    square: { type: Boolean, default: true },
    textButton: { type: Boolean, default: false }
  }
};
</script>
<style scoped>
.btn-class {
  font-weight: 700;
  width: 165px !important;
  padding-top: 9px;
  padding-bottom: 9px;
  height: auto;
  font-size: 16px;
  letter-spacing: 0.01em !important;
}
.w-auto {
  width: auto !important;
}
.theme-button {
  padding: 12px 30px !important;
  width: auto !important;
  height: auto !important;
}
</style>
